import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import ImageCard from "../../components/card/ImageCard";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import { $api } from "../../helper";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { statusShowMock, tokenMock } from "../../helper/mock";
import { useNavigate, useParams, useSearchParams } from "react-router";
import PreviewFile from "../../components/PreviewFile";
import { useNotify } from "../../helper/notify";

export default function AddSubCategory() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const params = useParams();
  const addCategory = $api.useMutation("post", "/site-api/v1/course/category/");
  const update = $api.useMutation("put", "/site-api/v1/course/category/");
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/course/category-detail/",
  );
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [fileMobile, setFileMobile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد دسته بندی دوره");
    if (
      searchParams.get("method") === "update" ||
      searchParams.get("method") === "update-department"
    ) {
      detail.mutate({
        params: {
          query: {
            category_u_id: params.category_u_id ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (
      (searchParams.get("method") === "update" ||
        searchParams.get("method") === "update-department") &&
      detail.data?.data
    ) {
      setFile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.desktop_image),
          id: detail.data.data.title + detail.data.data.u_id,
        },
      ]);
      setFileMobile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.mobile_image),
          id: detail.data.data.title + detail.data.data.u_id,
        },
      ]);
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      description: string;
      seo_title: string;
      seo_description: string;
      status: number;
      slug: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("title", values.title);
    if (searchParams.get("method") === "add-department") {
      formData.append("department_slug", params.departmentId || "");
    }
    if (searchParams.get("method") !== "add-department") {
      formData.append("category_u_id", params.category_u_id || "");
    }
    formData.append("status", values.status.toString());
    formData.append("description", values.description);
    formData.append("slug", values.slug);
    formData.append("seo_title", values.seo_title);
    formData.append("seo_description", values.seo_description);
    file.forEach((element) => {
      formData.append("desktop_image", element.file ?? element.fileUrl);
    });
    fileMobile.forEach((element) => {
      formData.append("mobile_image", element.file ?? element.fileUrl);
    });
    if (
      searchParams.get("method") === "update" ||
      searchParams.get("method") === "update-department"
    ) {
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(
                searchParams.get("method") === "add-department" ||
                  searchParams.get("method") === "update-department"
                  ? `/department-category/${params.departmentId}`
                  : `/department-category/${params.departmentId}/${data?.data?.parent_u_id}`,
              );
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      addCategory.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(
                searchParams.get("method") === "add-department" ||
                  searchParams.get("method") === "update-department"
                  ? `/department-category/${params.departmentId}`
                  : `/department-category/${params.departmentId}/${params.category_u_id}`,
              );
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <CustomBreadcrumb
        items={[
          {
            title: searchParams.get("name"),
            href:
              searchParams.get("method") === "add-department" ||
              searchParams.get("method") === "update-department"
                ? `/department-category/${params.departmentId}`
                : `/department-category/${params.departmentId}/${searchParams.get("parent") ? searchParams.get("parent") : params.category_u_id}`,
          },
          {
            title: "ایجاد دسته بندی",
          },
        ]}
      />
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به دسته‌بندی دوره"
        title="اطلاعات اصلی دسته‌بندی دوره"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("نام دسته بندی")}
            className="col-span-1"
            label="نام دسته بندی"
            inputProps={{
              placeholder: "لطفا نام دسته بندی خود را وارد کنید.",
            }}
          />
          <FormItemInput
            name={"slug"}
            rules={requireRules("اسلاگ")}
            className="col-span-1"
            label="اسلاگ"
            inputProps={{
              placeholder: "لطفا اسلاگ خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
        </div>
      </FormCard>
      <FormCard
        subTitle="تعریف و توضیحات کامل درباره دسته بندی"
        title="توضیحات"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInputTextarea
            name={"description"}
            rules={requireRules("توضیحات دسته بندی")}
            className="col-span-2"
            label="توضیحات دسته بندی"
            inputProps={{
              placeholder: "لطفا توضیحات دسته بندی خود را وارد کنید.",
              rows: 6,
            }}
          />
        </div>
      </FormCard>
      <FormCard
        title="تصاویر دسته‌بندی دوره ها"
        subTitle="تصاویر مربوط به نمایش دسته‌بندی دوره در نسخه‌های مختلف"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <div className="col-span-1 grid sm:grid-cols-5 grid-cols-2 gap-2">
            <div className="col-span-full">
              <ImageCard
                file={file}
                setFile={setFile}
                id="desktop_image-1"
                name="desktop_image"
              />
            </div>
            {file?.map((e, i) => (
              <div className="aspect-square col-span-1">
                <PreviewFile
                  id={e.id}
                  setFile={setFile}
                  url={e.fileUrl}
                  key={"preview" + i}
                />
              </div>
            ))}
          </div>
          <div className="col-span-1 grid grid-cols-5 gap-2">
            <div className="col-span-full">
              <ImageCard
                file={fileMobile}
                setFile={setFileMobile}
                mobile
                id="mobile_image-1"
                name="mobile_image"
              />
            </div>
            {fileMobile?.map((e, i) => (
              <div className="aspect-square col-span-1">
                <PreviewFile
                  id={e.id}
                  setFile={setFileMobile}
                  url={e.fileUrl}
                  key={"preview" + i}
                />
              </div>
            ))}
          </div>
        </div>
      </FormCard>
      <FormCard
        title="اطلاعات سئو"
        subTitle="بهینه‌سازی دسته‌بندی برای موتورهای جستجو"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            label="عنوان سئو"
            name={"seo_title"}
            rules={requireRules("عنوان سئو")}
            className="col-span-1"
            inputProps={{
              placeholder: "لطفا عنوان سئو خود را وارد کنید.",
            }}
          />
          <FormItemInputTextarea
            label="توضیحات"
            name={"seo_description"}
            rules={requireRules("توضیحات سئو")}
            className="col-span-1"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا توضیحات اضافی سئو خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={addCategory.isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
